var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHearthIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.334a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm7 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM18.667 12c0-.367-.3-.666-.667-.666-.367 0-.667.3-.667.666v3.334c0 .366.3.666.667.666.367 0 .667-.3.667-.666V12Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m9.512 19.546-7.529-7.03A6.233 6.233 0 0 1 0 7.955v-.241A5.955 5.955 0 0 1 10.167 3.5l.5.5.5-.5a5.957 5.957 0 0 1 10.166 4.213v.241c0 .275-.016.55-.054.817A7.335 7.335 0 0 0 18 8a7.333 7.333 0 0 0-6.07 11.445l-.11.1a1.691 1.691 0 0 1-2.308 0Z",
  opacity: 0.4
})));
export default SvgHearthIcon;